<template>
  <div class="h-full w-full flex justify-center items-center flex-wrap">
    <div class="w-full flex justify-center items-center px-4">
      <img
        src="@/assets/img/404.png"
        alt=""
        width="650px"
        class="h-auto overflow-hidden"
      />
    </div>
    <div class="w-full items-center flex justify-center">
      <router-link
        class="px-5 text-center py-3 text-lg rounded font-bold text-white bg-indigo-600 hover:bg-indigo-700 border-indigo-500"
        :to="{ name: 'login' }"
      >
        Voltar para ínicio
      </router-link>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style>
html,
body,
#app {
  height: 100%;
}
</style>
